import { render } from "./Text.vue?vue&type=template&id=e3ea82be"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiForms/fieldTypes/Text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e3ea82be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e3ea82be', __exports__)) {
    api.reload('e3ea82be', __exports__)
  }
  
  module.hot.accept("./Text.vue?vue&type=template&id=e3ea82be", () => {
    api.rerender('e3ea82be', render)
  })

}


export default __exports__